import React from 'react'
import { Button, ButtonProps } from '@mui/material'
import { Button as ContentfulButtonType } from '@talentinc/gatsby-theme-ecom/types/page'

const ContentfulButton: React.FC<
  Partial<ContentfulButtonType> & ButtonProps
> = ({ buttonText, ...props }) => <Button {...props}>{buttonText}</Button>

export default ContentfulButton
